import { render, staticRenderFns } from "./learn.start.vue?vue&type=template&id=71d73d82&scoped=true&"
import script from "./learn.start.vue?vue&type=script&lang=ts&"
export * from "./learn.start.vue?vue&type=script&lang=ts&"
import style0 from "./learn.start.vue?vue&type=style&index=0&id=71d73d82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d73d82",
  null
  
)

export default component.exports